// components/ExpertWidget.tsx
'use client';
import { useState, useEffect } from 'react';
import { api } from '../utils';
declare const grecaptcha: any;

export default function ExpertWidget({ pageTitle = 'Unknown Page' }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const form = document.getElementById('speakExpertForm') as HTMLFormElement;
    const inTouchSection = document.querySelector(
      '.speakExpertIntouch'
    ) as HTMLElement;
    const confirmationSection = document.querySelector(
      '.speakExpertConfirmation'
    ) as HTMLElement;

    if (form) {
      const handleSubmit = async (event: Event) => {
        event.preventDefault(); // Prevent default submission

        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        data.leadSourcePage = pageTitle;
        showLoader();
        console.log('Submitting form data:', data);

        // Execute reCAPTCHA v3
        const token = await grecaptcha.execute(
          process.env.NEXT_PUBLIC_CAPTCHA_KEY,
          {
            action: 'submit',
          }
        );
        const result = await api.post({
          path: 'logLead',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': token,
          },
        });
        console.log('API Response:', result);
        if (result.status === 'OK') {
          console.log('Form submission successful.');
          form.reset();
          if (inTouchSection && confirmationSection) {
            inTouchSection.style.display = 'none';
            confirmationSection.style.display = 'block';
          }
          showPopup('Form submitted successfully!');
        } else {
          console.error('Form submission failed.');
          showPopup('Form submission failed. Please try again.', true);
          hideLoader();
        }
      };

      form.addEventListener('submit', handleSubmit);

      return () => {
        form.removeEventListener('submit', handleSubmit);
      };
    }
  }, []);

  // Show loader
  const showLoader = () => {
    const loaderWrap = document.getElementById('loader-wrap') as HTMLElement;
    if (loaderWrap) loaderWrap.style.display = 'flex';
  };

  // Hide loader
  const hideLoader = () => {
    const loaderWrap = document.getElementById('loader-wrap') as HTMLElement;
    if (loaderWrap) loaderWrap.style.display = 'none';
  };

  // Popup Message Function
  const showPopup = (message: string, isError = false) => {
    const popup = document.createElement('div');
    popup.textContent = message;
    popup.style.position = 'fixed';
    popup.style.bottom = '20px';
    popup.style.left = '50%';
    popup.style.transform = 'translateX(-50%)';
    popup.style.padding = '10px 20px';
    popup.style.backgroundColor = isError ? '#ff4d4d' : '#4CAF50';
    popup.style.color = '#fff';
    popup.style.borderRadius = '5px';
    popup.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)';
    popup.style.zIndex = '1000';
    popup.style.fontSize = '16px';

    document.body.appendChild(popup);

    setTimeout(() => {
      popup.remove();
    }, 3000);
  };

  return (
    <>
      {/* Load Google reCAPTCHA v3 6LclXe0UAAAAABGHPN8IAa4w-KpYtvaI2s75aVvV */}
      <script
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_CAPTCHA_KEY}`}
        async
        defer
      ></script>

      <div className="speak-expert-floating">
        <form id="speakExpertForm">
          <ul>
            <li>
              <a
                className="help-link"
                id="speak-expert-link"
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpen(!isOpen);
                }}
              >
                Speak with an Expert!
              </a>
              <div
                className="speak-expert-box"
                id="speak-expert-box"
                style={{ display: isOpen ? 'block' : 'none' }}
              >
                {/* Goal Selection Step */}
                <div className="goal-selection">
                  <div className="title">Choose Your Path.</div>
                  <div className="desc">Your practice, your way</div>
                  <div className="form-item">
                    <select name="goal" id="goal" required>
                      <option value="" selected>
                        Select an option
                      </option>
                      <option value="Build a daily practice">
                        Build a daily practice
                      </option>
                      <option value="Deepen my practice">
                        Deepen my practice
                      </option>
                      <option value="Return to Sudarshan Kriya">
                        Return to Sudarshan Kriya
                      </option>
                      <option value="Explore before committing">
                        Explore before committing
                      </option>
                      <option value="I have questions / Other">
                        I have questions / Other
                      </option>
                    </select>
                  </div>
                  <div className="actions">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      id="notNowBtn"
                      onClick={() => setIsOpen(false)}
                    >
                      Not now
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      id="nextBtn"
                      onClick={() => {
                        const goalField = document.getElementById(
                          'goal'
                        ) as HTMLSelectElement;
                        if (goalField && goalField.checkValidity()) {
                          const intouchDiv = document.querySelector(
                            '.speakExpertIntouch'
                          ) as HTMLElement;
                          const goalSelectionDiv = document.querySelector(
                            '.goal-selection'
                          ) as HTMLElement;
                          if (intouchDiv && goalSelectionDiv) {
                            goalSelectionDiv.style.display = 'none';
                            intouchDiv.style.display = 'block';
                          }
                        } else {
                          goalField.reportValidity();
                        }
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>

                {/* Contact Information Step */}
                <div className="speakExpertIntouch" style={{ display: 'none' }}>
                  <div className="title">Let's Connect</div>
                  <div className="form-item">
                    <input
                      type="text"
                      name="fullName"
                      id="fullName"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="form-item">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email"
                      onBlur={(e) => {
                        const email = e.target.value;
                        const emailField = e.target as HTMLInputElement;
                        const emailRegex =
                          /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
                        if (!emailRegex.test(email)) {
                          emailField.setCustomValidity(
                            'Please enter a valid email address.'
                          );
                        } else {
                          emailField.setCustomValidity('');
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="form-item">
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Phone Number"
                      pattern="^\+?\d{10,}$"
                      title="Please enter a valid phone number with at least 10 digits."
                      required
                    />
                  </div>

                  <div className="actions">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      id="previousBtn"
                      onClick={() => {
                        const intouchDiv = document.querySelector(
                          '.speakExpertIntouch'
                        ) as HTMLElement;
                        const goalSelectionDiv = document.querySelector(
                          '.goal-selection'
                        ) as HTMLElement;
                        if (intouchDiv && goalSelectionDiv) {
                          intouchDiv.style.display = 'none';
                          goalSelectionDiv.style.display = 'block';
                        }
                      }}
                    >
                      Previous
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      id="submitBtn"
                    >
                      Submit
                    </button>
                  </div>
                  <div id="loader-wrap" style={{ display: 'none' }}>
                    <div className="loader"></div>
                  </div>
                </div>

                {/* Confirmation Step */}
                <div
                  className="speakExpertConfirmation"
                  style={{ display: 'none' }}
                >
                  <div style={{ marginBottom: '10px' }}>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="40"
                        height="40"
                        rx="20"
                        fill="url(#paint0_linear_18455_7841)"
                      ></rect>
                      <path
                        d="M22.8235 14.3416L23.9985 16.6916C24.1568 17.0166 24.5818 17.3249 24.9402 17.3916L27.0652 17.7416C28.4235 17.9666 28.7402 18.95 27.7652 19.9333L26.1068 21.5916C25.8318 21.8666 25.6735 22.4083 25.7652 22.8L26.2402 24.85C26.6152 26.4666 25.7485 27.1 24.3235 26.25L22.3318 25.0666C21.9735 24.85 21.3735 24.85 21.0152 25.0666L19.0235 26.25C17.5985 27.0916 16.7318 26.4666 17.1068 24.85L17.5818 22.8C17.6735 22.4166 17.5152 21.875 17.2402 21.5916L15.5818 19.9333C14.6068 18.9583 14.9235 17.9749 16.2818 17.7416L18.4068 17.3916C18.7652 17.3333 19.1902 17.0166 19.3485 16.6916L20.5235 14.3416C21.1485 13.0666 22.1818 13.0666 22.8235 14.3416Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M16.6641 14.1666H11.6641"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M14.1641 25.8334H11.6641"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M12.4974 20H11.6641"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <defs>
                        <linearGradient
                          id="paint0_linear_18455_7841"
                          x1="-14.8889"
                          y1="-16.3333"
                          x2="49.5961"
                          y2="-1.71006"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FFD16F"></stop>
                          <stop offset="1" stop-color="#FF865B"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="title">
                    A meditation and breathwork expert will reach out to discuss
                    your needs and guide your journey.
                  </div>
                  <div className="actions">
                    <button
                      type="button"
                      className="btn btn-primary"
                      id="okayBtn"
                      onClick={() => {
                        const speakExpertBox = document.getElementById(
                          'speak-expert-box'
                        ) as HTMLElement;
                        if (speakExpertBox) {
                          speakExpertBox.style.display = 'none';
                        }
                      }}
                    >
                      Okay
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </>
  );
}
